'use strict';
// @flow
interface User {
  password: string;
}

export default class ResetPasswordController {
  email: string = '';
  id: string = '';
  token: string = '';
  password: string = '';

  submitted = false;
  passwordUpdated: boolean = false;
  hasErrors: boolean = false;
  errorMessage: string = '';
  isTokenValid: boolean;

  $http;
  $state;
  TranslationService;

  /*@ngInject*/
  constructor($http, $state, TranslationService) {
    this.$http = $http;
    this.$state = $state;
    this.TranslationService = TranslationService;
  }

  $onInit() {
    this.token = this.$state.params.token;
    this.id = this.$state.params.id;

    if (!this.token) {
      this.isTokenValid = false;
      this.errorMessage = this.TranslationService.translate('reset_password_token_invalid');
      return false;
    }

    this.$http.get("/api/resetPasswords/verifyToken/"+ this.id +'/'+ this.token)
    .then(res => {
      if (res.data && res.data.valid) {
        this.isTokenValid = true;
      } else {
        this.isTokenValid = false;
        this.errorMessage = this.TranslationService.translate('reset_password_token_invalid');
      }
    });
  }

  submit(form) {
    this.submitted = true;

    if (!form.$valid) {
      this.errorMessage = this.getErrorMessage(form);
      this.hasErrors = true;
      return false;
    }
    
    this.hasErrors = false;

    // Send link 
    this.$http.post("/api/resetPasswords/reset/"+ this.id, {
      token: this.token,
      password: this.password
    }).then(res => {
      if (res.status == 204) { 
        this.passwordUpdated = true;
      }
    }).catch(err => {
      this.errorMessage = this.TranslationService.translate('reset_password_error');
      this.hasErrors = true;
    });
  }

  getErrorMessage(form) {
    if(form.password.$error.required) {
      return this.TranslationService.translate('pw_required');
    }

    if(form.password.$error.minlength) {
      return this.TranslationService.translate('pw_min_4_char');
    }

    if (form.confirmPassword.$viewValue !== form.password.$viewValue) {
      return this.TranslationService.translate('pw_must_match');
    }

    return this.TranslationService.translate('reset_password_error');
  }

  goToLogin() {
    this.$state.go('login');
  }
}



// WEBPACK FOOTER //
// ./client/app/account/resetPassword/resetPassword.controller.ts